export const environment = {
        keycloak:{
        loginUrl: 'https://uat-api-gw.internal-nprod.incred.com',
        realm: 'incred',
        clientId: 'loan-document-dump',  
        googleClientId: '95024585348-eh5410psnloacbm1rq01dvkiphga6ch5.apps.googleusercontent.com',
        oauthRedirectUrl: 'https://assets.incred.com/auth-handler/index.html',
    },
    production: false,
    apiEndpoint: 'https://document-service.internal-prod.incred.com',
    gatwayURL: 'https://gateway-api.incred.com',
    UAM_ROLE:`https://uat-api-gw.internal-nprod.incred.com/v3/uam/access`,
    s3Config: {
        key: 'lms-loan-dump',    
        bucketName: 'incred-databricks-data',
    }
};
